const en = {
	unrepliedChargeback: 'Unreplied Chargeback',
	unrepliedRetrieval: 'Unreplied Retrieval',
	unrepliedRiskTransaction: 'Unreplied Risk Transaction',
	balance: 'Balance',
	accountBalance: 'Balance',
	totalUsdBalance: 'Total Balance',
	totalUsdBalanceTip: 'The total balance is the sum of the "balance" of each currency account converted into USD.',
	available: 'Available：',
	WITHDRAW: 'WITHDRAW',
	frozenBalance: 'Frozen Balance',
	rollingReserveBalance: 'Rolling Reserve Balance',
	noaccount:
    'Currency account has not been configured for this group，please wait patiently.',
	allGroups: 'All Groups',
	noFeeSetting:
    'The configuration related to this withdrawal is incorrect, please contact salers as soon as possible.',

	tradeSum: 'Transaction Summary',
	group: 'Group',
	website: 'Website',
  	omniWebsite: 'Website/Store',
	currency: 'Currency',
	today: 'TODAY',
	successfulAmount: 'Successful Amount',
	todayNumber: 'Number of Transactions',
	currentMonth: 'CURRENT MONTH',
	accumulated: 'ACCUMULATED',
	settledAccount: 'Settled Amount',
	settledNumber: 'Settled Count',
	unsettledAccount: 'Unsettled Amount',
	unsettledNumber: 'Unsettled Count',
	todaySettled: "Today's Settled",
	todayUnsettled: "Today's Unsettled",
	monthSettled: ' Monthly Settled',
	monthUnsettled: 'Monthly Unsettled',
	historySettled: 'Cumulative Settled',
	historyUnsettled: 'Cumulative Unsettled',
	cbSum: 'Chargeback Summary',
	cbSumTips: 'The counts/amount of chargebacks is calculated according to 1st_chargeback.  The statistical time is calculated according to the time entered into the PingPongPay system.',
	covertedUSD: 'The amount is for reference only. If you need to see the currency, please specify the currency of the transaction',
	cbAmount: 'Chargeback Amount',
	cbNumber: 'Number of Chargebacks',
	acRate: 'Chargeback rate',
	cbWarningAmount: 'Chargeback Warning Amount',
	cbWarningNumber: 'Number of Chargeback Warning',
	tip: 'The amount is converted into US dollars (for reference only',
	cbCurrentMonth: 'CURRENT MONTH',
	cbAccumulated: 'ACCUMULATED',
	operatingGuide: 'Merchant admin operating guide',
	guide: {
		videoTitle: 'Video Explanation',
		textTitle: 'For text materials, please download',
		video1: 'Part1：Home',
		video2: 'Part2：Transaction、Settlement',
		video3: 'Part3：Chargeback',
		video4: 'Part4：Withdrawal'
	},
	certificatePending: 'The certificate is reviewing'
}

export default en
